import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Container, Row, Col } from 'react-bootstrap';
import { PersonFill, BriefcaseFill, PeopleFill } from 'react-bootstrap-icons';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import API_BASE_URL from '../config'; // Assuming you have a config file with the API base URL

const SelectRole = () => {
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleRoleSelection = async (role) => {
        setIsLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            const res = await axios.post(
                `${API_BASE_URL}/select-role`,
                { role },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.token) {
                // Update token and user data
                localStorage.setItem('token', res.data.token);
                const decoded = jwtDecode(res.data.token);
                localStorage.setItem('user', JSON.stringify(decoded));

                // Redirect based on role
                if (res.data.type === 'customer') {
                    navigate('/manage-bookings');
                } else if (res.data.type === 'user') {
                    navigate('/companies');
                } else if (res.data.type === 'both') {
                    navigate('/role-select');
                }
            } else {
                setError(res.data.message || 'Role selection failed');
            }
        } catch (error) {
            console.error('Error selecting role:', error);
            setError('Failed to process role selection');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="py-5 text-center">
            <h2 className="mb-4 fw-bold">Select Your Role</h2>
            {error && <p className="text-danger">{error}</p>}
            <Row className="justify-content-center g-4">
                <Col xs={12} md={4}>
                    <Card
                        className="shadow-sm hover-shadow border-0"
                        onClick={() => handleRoleSelection('customer')}
                        style={{ cursor: 'pointer' }}
                    >
                        <Card.Body>
                            <PersonFill size={48} className="text-primary mb-3" />
                            <Card.Title>Customer</Card.Title>
                            <Card.Text>Book and manage your appointments easily.</Card.Text>
                            <Button variant="primary" disabled={isLoading}>
                                Continue as Customer
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4}>
                    <Card
                        className="shadow-sm hover-shadow border-0"
                        onClick={() => handleRoleSelection('user')}
                        style={{ cursor: 'pointer' }}
                    >
                        <Card.Body>
                            <BriefcaseFill size={48} className="text-success mb-3" />
                            <Card.Title>Business Owner</Card.Title>
                            <Card.Text>Manage your services, staff, and customers.</Card.Text>
                            <Button variant="success" disabled={isLoading}>
                                Continue as Business Owner
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4}>
                    <Card
                        className="shadow-sm hover-shadow border-0"
                        onClick={() => handleRoleSelection('both')}
                        style={{ cursor: 'pointer' }}
                    >
                        <Card.Body>
                            <PeopleFill size={48} className="text-info mb-3" />
                            <Card.Title>Both</Card.Title>
                            <Card.Text>Book appointments and manage your business.</Card.Text>
                            <Button variant="info" disabled={isLoading}>
                                Continue as Both
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default SelectRole;